import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useLastMembersPrograms({ demo }) {
  const [programs, setPrograms] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.super_admins.session_rooms.index, {
        params: {
          demo,
        },
      })
      .then((response) => {
        setPrograms(response.data.data);
      });
  }, []);

  return programs;
}
